import noAnalyticsProvider from "./noAnalyticsProvider";
import { AnalyticsProvider } from "./AnalyticsProvider";
import { createContext } from "react";

const AnalyticsContext = createContext<AnalyticsProvider>(noAnalyticsProvider);

AnalyticsContext.displayName = "AnalyticsContext";

export { AnalyticsContext }
